module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.swiperSlides.length > 0) ? _c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.swiperSlides), function(slide) {
    return _c('swiper-slide', {
      key: slide.index
    }, [_c('div', {
      staticClass: "count-wrap ",
      class: {
        greenstyle: slide.foodUseable < 55, bluestyle: slide.foodUseable >= 55 && slide.foodUseable <= 70
      }
    }, [_c('div', {
      staticClass: "count-inner"
    }, [_c('div', {
      staticClass: "count-text"
    }, [_vm._v("血糖指数")]), _vm._v(" "), _c('div', {
      staticClass: "count-num"
    }, [_c('span', {
      class: {
        hightip: slide.foodUseable > 70
      }
    }, [_vm._v(_vm._s(slide.foodUseable))])])])]), _vm._v(" "), _c('div', {
      staticClass: "result-wrap text-center"
    }, [_c('div', {
      staticClass: "gis-title ellipsis"
    }, [_vm._v(_vm._s(slide.foodTitle))]), _vm._v(" "), (slide.foodThumb) ? _c('div', {
      staticClass: "result-thumb gis-thumb"
    }, [_c('img', {
      attrs: {
        "src": slide.foodThumb
      }
    })]) : _vm._e(), _vm._v(" "), (slide.foodUseable > 70) ? _c('div', {
      staticClass: "result-time gis-resultip"
    }, [_vm._v("\r\n\t\t\t\t\t属于高血糖生成指数食物，建议少吃\r\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (slide.foodUseable < 55) ? _c('div', {
      staticClass: "result-time gis-resultip"
    }, [_vm._v("\r\n\t\t\t\t\t属于低血糖生成指数食物，建议多吃\r\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (slide.foodUseable >= 55 && slide.foodUseable <= 70) ? _c('div', {
      staticClass: "result-time gis-resultip"
    }, [_vm._v("\r\n\t\t\t\t\t属于中等血糖生成指数食物，建议适量食用\r\n\t\t\t\t")]) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.gohome()
      }
    }
  }, [_vm._v("返回首页")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7093c466"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/blood_sugar/gis.vue
// module id = 148
// module chunks = 1